import _isIterable from "./_isIterable";
export default function* _toIterator(list) {
    if (_isIterable(list)) {
        yield* list;
    } else {
        for(let i = 0; i < list.length; i++){
            yield list[i];
        }
    }
}
